<template>
  <Ibox :title="'Edycja skróconego linku'">
    <template slot="content" slot-scope="{ setLoading }">
      <Form slot="content" @loading="setLoading" />
    </template>
  </Ibox>
</template>

<script>
import Ibox from "@/components/base/Ibox.vue";
import Form from "@/components/ShortRedirectUrl/Form.vue";

export default {
  name: "ShortRedirectUrlDetails",
  components: {
    Ibox,
    Form
  }
};
</script>
